import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initializeTelemetryServices } from './services/telemetry';

initializeTelemetryServices();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = createRoot(rootElement);
LicenseInfo.setLicenseKey(import.meta.env.VITE_REACT_APP_MUI_PRO_LICENCE_KEY);

if (typeof global === 'undefined') {
  (window as any).global = window;
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

root.render(<App />);
